import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { media } from "../app/schema";

export const GET_MEDIAS = "GET_MEDIAS";
export const GET_MEDIA = "GET_MEDIA";
export const DELETE_MEDIA = "DELETE_MEDIA";
export const PATCH_MEDIA = "PATCH_MEDIA";

export const SET_IS_EDIT_MEDIA_MODAL_VISIBLE =
  "SET_IS_EDIT_MEDIA_MODAL_VISIBLE";
export const SET_IS_REMOVE_MEDIA_MODAL_VISIBLE =
  "SET_IS_REMOVE_MEDIA_MODAL_VISIBLE";
export const SELECT_MEDIA_ITEM = "SELECT_MEDIA_ITEM";
export const UNSELECT_MEDIA_ITEM = "UNSELECT_MEDIA_ITEM";
export const RESET_SELECTED_MEDIA_ITEMS = "RESET_SELECTED_MEDIA_ITEMS";

// Validation
const validateForm = {
  createMedia: (validate, fields, oneField) =>
    validate(fields, oneField) // .prop('name', 'Nazwa').required()
      .getErrors().promise
};

// Requests

const getMediasGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/medias?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getMediaGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/medias/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchMedia = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/medias/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteMedia = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/medias/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg:
          "Nie można usunąć danych kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function getMedias(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MEDIAS],
    payload: {
      promise: getMediasGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { medias: arrayOf(media) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getMedia(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_MEDIA],
    payload: {
      promise: getMediaGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, media);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateMedia(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_MEDIA],
    payload: {
      promise: patchMedia(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, media);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeMedia(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_MEDIA],
    payload: {
      promise: deleteMedia(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsEditMediaModalVisible(value) {
  return {
    type: SET_IS_EDIT_MEDIA_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}

export function setIsRemoveMediaModalVisible(value) {
  return {
    type: SET_IS_REMOVE_MEDIA_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}

export function selectMediaItem(value) {
  return {
    type: SELECT_MEDIA_ITEM,
    data: {
      item: value
    }
  };
}

export function unselectMediaItem(value) {
  return {
    type: UNSELECT_MEDIA_ITEM,
    data: {
      item: value
    }
  };
}

export function resetSelectedMediaItems() {
  return {
    type: RESET_SELECTED_MEDIA_ITEMS
  };
}

// Standard functions
export function validateFormFieldMedias(form, name, value) {
  const feature = "medias";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/media/actions.js